module.exports = __webpack_public_path__ + "img/shopping-cart.c9ec7dc0.svg";